/* Native cart posts remain authoritative. No cart mutation, checkout navigation or tracking is simulated here. */
(function () {
  'use strict';
  function init(form) {
    if (form.dataset.lnCartReady === 'true') return;
    form.dataset.lnCartReady = 'true';
    var inputs = Array.from(form.querySelectorAll('input[name="updates[]"]'));
    var initial = inputs.map(function (input) { return input.value; });
    var notice = form.querySelector('[data-ln-cart-dirty]');
    var estimates = Array.from(form.querySelectorAll('[data-ln-cart-estimate]'));
    var submitting = false;
    function dirty() {
      var changed = inputs.some(function (input, index) { return input.value !== initial[index]; });
      if (notice) notice.hidden = !changed;
      estimates.forEach(function (element) { element.hidden = changed; });
      form.classList.toggle('ln-cart14--dirty', changed);
    }
    inputs.forEach(function (input) {
      input.addEventListener('input', function () { input.setCustomValidity(''); dirty(); });
      input.addEventListener('change', dirty);
    });
    form.addEventListener('submit', function (event) {
      if (submitting) { event.preventDefault(); return; }
      var invalid = inputs.find(function (input) {
        return input.value.trim() === '' || !Number.isSafeInteger(Number(input.value)) || Number(input.value) < 0;
      });
      if (invalid) {
        event.preventDefault();
        invalid.setCustomValidity('Vælg et helt antal på mindst 0.');
        invalid.reportValidity();
        return;
      }
      if (event.defaultPrevented) return;
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      // Do not disable the successful submitter: Shopify needs name=checkout or name=update.
      form.querySelectorAll('button[type="submit"]').forEach(function (button) { button.setAttribute('aria-disabled', 'true'); });
    });
    function unlock() {
      submitting = false;
      form.removeAttribute('aria-busy');
      form.querySelectorAll('button[type="submit"]').forEach(function (button) { button.removeAttribute('aria-disabled'); });
      dirty();
    }
    window.addEventListener('pageshow', unlock);
    dirty();
  }
  function start() { document.querySelectorAll('[data-ln-cart-form]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
